"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var radiobutton_1 = require("./radiobutton");
Object.defineProperty(exports, "RadioButton", { enumerable: true, get: function () { return __importDefault(radiobutton_1).default; } });
//# sourceMappingURL=index.js.map